import styled from 'styled-components'

export const Container = styled.div`
    width: 2rem;
    height: 2rem;
    margin-right: 1rem;

    border: 2px solid gray;
    border-radius: 5px;

    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;

    svg{
        position: absolute;
        top: -0.5rem;
        right: 0;
        left: 0;
        font-size: 2.2rem;
        color: #7A05A7;
    }

    @media (min-width: 960px){
        cursor: pointer;
    }
`